
import useValidation from "../../hooks/useValidation";
import { useEffect, useState } from "react";
import { LegalEntityType, LegalEntityTypeOfficiant, Tribunal } from "../../static/types/commonTypes/legalEntityType";
import { DateType } from "../../static/types/commonTypes/dateType";
import { format, parse, isValid } from "date-fns";
import TribunalValidationSchema from "../../utils/validation/tribunalValidationSchema";

type NotaireOfficiantProps = {
    checkeTribunal: boolean,
    Tribunal: Tribunal,
    changeTribunal: (data: Partial<Tribunal>) => void,
    onValidationChangeTribunal: (isValid: boolean) => void
}

export default function TribunalJudiciaire({
    checkeTribunal,
    Tribunal,
    changeTribunal,
    onValidationChangeTribunal,
}: NotaireOfficiantProps) {

    const { errors, isValid:isDataValid } = useValidation(Tribunal, TribunalValidationSchema);
    const [selectedEffectiveDate, setSelectedEffectiveDate] = useState<string>("");

    useEffect(() => {
        if (Tribunal.dateDépot) {
            const parsedDate = parse(Tribunal.dateDépot, "dd/MM/yyyy", new Date());
            setSelectedEffectiveDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
    }, [Tribunal]);

    useEffect(() => {
        onValidationChangeTribunal(isDataValid)
    }, [isValid, onValidationChangeTribunal])

    const handleEffectiveDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        if (!inputDate) {
            setSelectedEffectiveDate("");
            changeTribunal({ dateDépot: "" });
            return;
        }

        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());

        const formattedDate = format(parsedDate, "dd/MM/yyyy");
        setSelectedEffectiveDate(inputDate);
        changeTribunal({ dateDépot: formattedDate });
    };

    const openDatePicker = (id: string) => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return (

        <div className="mb-3 row">

            <div className="mb-3 row">
                <label htmlFor="greffe" className="col-sm-2 col-form-label required"> Greffe du TJ  <strong className="text-danger">*</strong>  </label>
                <div className="col-sm-4">
                    <input
                        className={`description-input form-control ${(checkeTribunal && errors.greffe) ? 'is-invalid' : ''}`}
                        type="text"
                        name="greffe"
                        id="greffe"
                        value={Tribunal.greffe}
                        onChange={event => changeTribunal({ greffe: event.target.value })}
                    />
                    {(checkeTribunal && errors.greffe) && <div className="invalid-feedback"> {errors.greffe} </div>}
                </div>
            </div>

            <div className="mb-3 row">
                <label htmlFor="datetribunal" className="col-2 col-form-label fw-bold mb-1">
                    Date de dépôt <strong className="text-danger">*</strong>
                </label>
                <div className="col-6" >
                    <input
                        className={`form-control ${(checkeTribunal && errors.dateDépot) ? 'is-invalid' : ''}`}
                        type="date"
                        id="datetribunal"
                        value={selectedEffectiveDate}
                        onChange={handleEffectiveDateChange}
                        onClick={() => openDatePicker("datetribunal")}
                        placeholder="JJ/MM/AAAA"
                    />
                    {(checkeTribunal && errors.dateDépot) && <div className="invalid-feedback"> {errors.dateDépot} </div>}
                </div>
            </div>

            <div className="mb-3 row">
                <label htmlFor="numeroRole" className="col-sm-2 col-form-label">Numéro de rôle<strong className="text-danger">*</strong>  </label>
                <div className="col-sm-4">
                    <input
                        className={`form-control ${(checkeTribunal && errors.numeroRole) ? 'is-invalid' : ''}`}
                        type="text"
                        name="numeroRole"
                        id="numeroRole"
                        value={Tribunal.numeroRole}
                        onChange={event => changeTribunal({ numeroRole: event?.target.value })}
                    />
                    {(checkeTribunal && errors.numeroRole) && <div className="invalid-feedback"> {errors.numeroRole} </div>}
                </div>
            </div>
        </div>
    )
}